export class OrganizationSelectedModel {
	selected: number[];
}
